import React, { useState, useEffect } from 'react';
import { Input } from '../../../../../components/input';
import { createTicketComment } from '../../../../../store/action/ticket';

const CommentInput = (props) => {
    const [ values, setValues ] = useState({
        content:''
    });

    const onSubmitComment = async () => {

        const response = await createTicketComment(props.ticketId,values);
        if (response.success) {
            props.onRefreshView();
        } else {
            alert(response.error)
        }
    }
    return (
        <div className="border-top border-bottom pt-3 px-4">
            <div className='form-row'>
                <Input
                    className="col-10"
                    placeholder="Masukkan komen baru Anda"
                    onChange={e => setValues({...values,content:e.target.value})}
                />
                <div className='col-2'>
                    <button
                        className="btn btn-sm btn-primary btn-block"
                        onClick={onSubmitComment}
                    >
                        Submit
                    </button>
                </div>
               
            </div>
           
        </div>
    )
};

export default CommentInput